import { css } from "@emotion/react";
import { Button } from "../../Button";
import { Mode } from "../CSVImportUI";
import { ScreenLayout } from "../ScreenLayout";
import { useNavigate } from "../ScreenProvider";
import { ScreenProps } from "./types";

export interface SelectModeScreenProps extends ScreenProps {
  onChangeMode: (mode: Mode) => void;
  skipDownloadTemplate?: boolean;
  title?: string;
}

export const SelectModeScreen = ({
  onChangeMode,
  skipDownloadTemplate,
  title = "インポートの選択",
}: SelectModeScreenProps) => {
  const { onNavigate } = useNavigate();

  return (
    <ScreenLayout title={title}>
      <div
        css={css`
          display: flex;
          gap: 8px;
          justify-content: center;
        `}
      >
        <Button
          variant="outlined"
          color="primary"
          onClick={() => {
            onChangeMode("create");
            onNavigate(
              skipDownloadTemplate ? "loadCSV" : "downloadCreateTemplate",
            );
          }}
        >
          新規作成
        </Button>
        <Button
          variant="outlined"
          color="primary"
          onClick={() => {
            onChangeMode("update");
            onNavigate(
              skipDownloadTemplate ? "loadCSV" : "downloadUpdateTemplate",
            );
          }}
        >
          更新
        </Button>
      </div>
    </ScreenLayout>
  );
};
